import { generateImagePath } from '../../../../helpers/helpers';
import AddMoreButton from '../inputs/AddMoreButton';
import { commonFieldConfig, commonFieldTypes } from '../inputs/field.config';
import FieldTypeSelector from '../inputs/Index';

export default function WhyInvestSection({
  investmentData,
  handleInputChange,
  handleAddItem,
  dispatch,
  removeItemFromArray,
}) {
  // English Why Invest Fields
  const whyInvestSectionFieldsEn = [
    {
      label: 'Why Invest Title',
      value: investmentData.en.whyInvestSection.title,
      section: 'whyInvestSection',
      field: 'title',
      config: { ...commonFieldConfig['en'][commonFieldTypes.text] },
    },
  ];
  const imageSection = {
    label: 'Why Invest Image URL',
    value: investmentData.en.whyInvestSection.image,
    section: 'whyInvestSection',
    field: 'image',
    config: { ...commonFieldConfig['en'][commonFieldTypes.image] },
  };

  // Arabic Why Invest Fields
  const whyInvestSectionFieldsAr = [
    {
      label: 'عنوان لماذا الاستثمار',
      value: investmentData.ar.whyInvestSection.title,
      section: 'whyInvestSection',
      field: 'title',
      config: { ...commonFieldConfig['ar'][commonFieldTypes.text] },
    },
  ];

  // English List Items
  const whyInvestSectionListFieldsEn =
    investmentData.en.whyInvestSection.list.map((item, index) => ({
      label: `List Item ${index + 1}`,
      value: item,
      section: 'whyInvestSection',
      field: 'list',
      index,
      config: { ...commonFieldConfig['en'][commonFieldTypes.text] },
    }));

  // Arabic List Items
  const whyInvestSectionListFieldsAr =
    investmentData.ar.whyInvestSection.list.map((item, index) => ({
      label: `عنصر القائمة ${index + 1}`,
      value: item,
      section: 'whyInvestSection',
      field: 'list',
      index,
      config: { ...commonFieldConfig['ar'][commonFieldTypes.text] },
    }));

  return (
    <section className="mb-5">
      <h3 className="mb-3">Why Invest Section</h3>
      <img
        src={generateImagePath('why-invest-section.webp')}
        alt=""
        className="mb-3 w-100"
      />

      <div className="row">
        <div className="col-md-6">
          {whyInvestSectionFieldsEn.map((field, index) => (
            <FieldTypeSelector
              key={index}
              label={field.label}
              fieldName={field.field}
              value={field.value}
              config={field.config}
              onInputChange={(e) =>
                handleInputChange({
                  e,
                  section: field.section,
                  field: field.field,
                  lang: 'en',
                  isSameValue: field.config.isSameValue,
                })
              }
            />
          ))}
        </div>

        <div className="col-md-6" dir="rtl">
          {whyInvestSectionFieldsAr.map((field, index) => (
            <FieldTypeSelector
              key={index}
              label={field.label}
              fieldName={field.field}
              value={field.value}
              config={field.config}
              onInputChange={(e) =>
                handleInputChange({
                  e,
                  section: field.section,
                  field: field.field,
                  lang: 'ar',
                  isSameValue: field.config.isSameValue,
                })
              }
            />
          ))}
        </div>
      </div>
      <div>
        {imageSection && (
          <FieldTypeSelector
            fieldName={imageSection.field}
            label={imageSection.label}
            value={imageSection.value}
            config={imageSection.config}
            onInputChange={(e) =>
              handleInputChange({
                e,
                section: imageSection.section,
                field: imageSection.field,
                lang: 'ar',
                isSameValue: imageSection.config.isSameValue,
              })
            }
          />
        )}
      </div>
      <div className="row">
        <div className="col-md-6">
          <h4 className="mt-4 mb-3">Why Invest List</h4>
          {whyInvestSectionListFieldsEn.map((field, index) => (
            <FieldTypeSelector
              key={index}
              label={field.label}
              fieldName={field.field}
              value={field.value}
              onInputChange={(e) =>
                handleInputChange({
                  e,
                  section: field.section,
                  field: field.field,
                  lang: 'en',
                  index: field.index,
                })
              }
              config={field.config}
              removeFromList={() =>
                dispatch(
                  removeItemFromArray({
                    section: field.section,
                    field: field.field,
                    index,
                  }),
                )
              }
            />
          ))}
        </div>

        <div className="col-md-6" dir="rtl">
          <h4 className="mt-4 mb-3">قائمة لماذا الاستثمار</h4>
          {whyInvestSectionListFieldsAr.map((field, index) => (
            <FieldTypeSelector
              key={index}
              label={field.label}
              fieldName={field.field}
              value={field.value}
              onInputChange={(e) =>
                handleInputChange({
                  e,
                  section: field.section,
                  field: field.field,
                  lang: 'ar',
                  index: field.index,
                })
              }
              config={field.config}
              removeFromList={() =>
                dispatch(
                  removeItemFromArray({
                    section: field.section,
                    field: field.field,
                    index,
                  }),
                )
              }
            />
          ))}
        </div>

        <AddMoreButton
          handleAddItem={() => handleAddItem('whyInvestSection', 'list')}
        />
      </div>
    </section>
  );
}
